@use "../../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .container {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }

      .preview {
        cursor: pointer;
        color: colors.$mmc-primary-100;
      }

      .label {
        color: colors.$mmc-soft-slate;
      }
    }
  }
}
